export const copyToClipboard = async (copyText: string) => {
  await navigator.clipboard.writeText(copyText);
};
